import { useState } from 'react';
import DashboardContext, { DashboardContextProps } from './DashboardContext';

interface DashboardProviderProps {
  children: React.ReactNode;
}

const DashboardProvider = ({ children }: DashboardProviderProps) => {
  const [agentsCount, setAgentsCount] = useState<number>(0);

  return (
    <DashboardContext.Provider
      value={{
        agentsCount,
        setAgentsCount,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
